import { useQuery } from 'react-query';
import { Dayjs } from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';

export const useGetTotalAdCost = (identifier: string, from: Dayjs | null, to: Dayjs | null) => {
  const queryParams = new URLSearchParams();
  const navigate = useNavigate();
  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));

  const queryKey = generateQueryKey(identifier, queryParams);

  return useQuery(
    [`reports_${queryKey}`],
    () => dataFetch
      .get(`${CORE_API_SUFFIX}ad/total/cost?${queryParams}`)
      .then((res) => res.data),
    {
      onSuccess: () => {
        navigate(`${window.location.pathname}?${queryParams.toString()}`, { replace: true });
      },
    },
  );
};
